import styled from 'styled-components';
import Modal from 'calcite-react/Modal';

export const StyledItemResourceModal = styled(Modal)`
  max-width: 35vw;
  width: 35vw;
`;
